import { observer } from 'mobx-react';
import { ClientItemId } from 'owa-client-ids';
import { DayGridScenario, DayGridView } from 'owa-day-grid';
import strings from 'owa-strings/owa-time-panel';
import React from 'react';

const styles = require('./ConflictsView.scss');

export interface ConflictsViewProps {
    selectedEventId?: ClientItemId;
}

@observer
export default class ConflictsView extends React.Component<ConflictsViewProps> {
    render() {
        return (
            <>
                <div className={styles.header}>{strings.conflictsTitleText}</div>
                <div className={styles.conflictsContainer}>
                    <DayGridView
                        scenario={DayGridScenario.ConflictsView}
                        selectedEventId={this.props.selectedEventId}
                    />
                </div>
            </>
        );
    }
}
